import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c9f4d3e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container filters mb-3 error-container" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col error" }
const _hoisted_4 = {
  class: "alert alert-warning d-flex flex-column align-items-center justify-content-center mt-3 mb-3",
  role: "alert"
}
const _hoisted_5 = { class: "mt-0" }
const _hoisted_6 = { class: "mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, "Error " + _toDisplayString($props.status), 1),
          _createElementVNode("h2", _hoisted_6, _toDisplayString($props.message), 1)
        ])
      ])
    ])
  ]))
}